import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { BLOG_POSTS } from '../../data/blogData'

const JournalSection = () => {
  const [featured, ...secondary] = BLOG_POSTS.slice(0, 4)

  return (
    <section className="w-full bg-museum-ivory pt-12 pb-20 md:pt-16 md:pb-28">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <motion.div
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12 md:mb-16"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="max-w-xl">
            <p className="text-[10px] uppercase tracking-[0.35em] text-museum-antique-gold font-sans font-semibold mb-5">
              04 &mdash; The Journal
            </p>
            <h2 className="font-editorial italic font-normal text-museum-black leading-[0.95]" style={{ fontSize: 'clamp(2.25rem, 4.4vw, 3.5rem)' }}>
              The Heritage Journal
            </h2>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-2 text-museum-black/60 hover:text-museum-antique-gold text-[11px] font-sans font-semibold uppercase tracking-[0.22em] transition-colors shrink-0">
            View All <ArrowRight size={13} />
          </Link>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-16">
          {/* Featured article */}
          {featured && (
            <motion.div
              className="lg:col-span-7"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
            >
              <Link to={`/blog/${featured.slug}`} className="group block">
                <div className="relative aspect-[16/10] overflow-hidden mb-6 bg-museum-black/5">
                  <img
                    src={featured.imageLow}
                    alt={featured.title}
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-[900ms] ease-out"
                  />
                </div>
                <p className="text-[10px] uppercase tracking-[0.22em] text-museum-antique-gold font-sans font-semibold mb-3">
                  {featured.category}
                </p>
                <h3 className="font-editorial italic text-museum-black leading-[1.05] mb-3" style={{ fontSize: 'clamp(1.5rem, 2.6vw, 2.1rem)' }}>
                  {featured.title}
                </h3>
                <p className="text-museum-black/55 font-sans text-sm leading-relaxed max-w-lg">{featured.excerpt}</p>
              </Link>
            </motion.div>
          )}

          {/* Secondary articles */}
          {secondary.length > 0 && (
            <div className="lg:col-span-5">
              {secondary.map((post, i) => (
                <motion.div
                  key={post.slug}
                  className="py-6 border-t border-museum-antique-gold/15 last:border-b"
                  initial={{ opacity: 0, x: 12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                >
                  <Link to={`/blog/${post.slug}`} className="group flex items-start gap-5">
                    <div className="shrink-0 w-24 h-24 overflow-hidden bg-museum-black/5">
                      <img
                        src={post.imageLow}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                      />
                    </div>
                    <div className="min-w-0">
                      <p className="text-[9px] uppercase tracking-[0.2em] text-museum-antique-gold font-sans font-semibold mb-1.5">
                        {post.category}
                      </p>
                      <h4 className="font-editorial italic text-museum-black text-lg leading-snug group-hover:text-museum-antique-gold transition-colors">
                        {post.title}
                      </h4>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default JournalSection
